import { render } from "./SubmitReportSignUpOption.vue?vue&type=template&id=bb1c5102&scoped=true&ts=true"
import script from "./SubmitReportSignUpOption.vue?vue&type=script&lang=ts"
export * from "./SubmitReportSignUpOption.vue?vue&type=script&lang=ts"

import "./SubmitReportSignUpOption.vue?vue&type=style&index=0&id=bb1c5102&scoped=true&lang=scss"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb1c5102"]])

export default __exports__